module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAAkklEQVQoU4WOPa5BYQBEz1mIRKOQIKzGGrQKEaVGFOrX28Wr3w78FMQ2KI183NwI8kwzmWTOZEwyAtbqmS9KMjTJH9BQm//1k8yAuaWUZFdc7XyCkkyBBTC4AxV0AK5q+xlKMgZWQEfd10AFHYGL2q/yBFgCXfXx4vVCkhOwBX6BH6CnlnzXG1Atb8oq0FLLQK0b9sU4ggbBAvoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/open.png
// module id = YFP6
// module chunks = 1